import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import creditzActions from "../../../../redux/creditz/actions";
import { Row, Col } from "antd";
import PropTypes from "prop-types";
import axios from "axios";

import { database } from "../../../../firebase";

import SelectArrow from "../../../../components/selectArrow";
import AddNewAdditionalInfo from "../addNewAdditionalInfo";
import { useOutsideAlerter } from "../../../../hooks/utils";
import { userRoles } from "../../../../assets/constants";
import styles from "./style.module.scss";
import musicBig from "../../../../assets/images/creditz/musicBig";

const CreateNewCreditzForm = ({
  setPublishActive,
  setValues,
  values = {},
  publishActive,
  additionalRoles1,
  setView,
}) => {
  const dispatch = useDispatch();
  const [selectedType, setSelectedType] = useState(
    values.trackName ? "Audio" : "Video"
  );
  const [showTypesOptions, setShowOptions] = useState(false);
  const [showRolesOptions, setShowRoles] = useState(false);
  const [selectedRole, setSelectedRole] = useState(
    values.role ? values.role : "Artist"
  );
  const [youtubeLink, setYoutubeLink] = useState(values.trackUrl);
  const [youtubeLinkErr, setYoutubeLinkErr] = useState();
  const [artistName, setArtistName] = useState(values.artistName);
  const [videoTrackName, setVideoTitle] = useState(values.videoTrackName);
  const [trackName, setTrackName] = useState(values.trackName);
  const [videoImage, setVideoImage] = useState(values.videoImage);
  const [additionalRoles, setAddRoles] = useState(additionalRoles1);
  const [allUsers, setAllUsers] = useState([]);

  const setAdditionalUser = (r) => {
    additionalRoles[r.i] = r;
  };

  const optionsRef = useRef(null);
  const rolesRef = useRef(null);
  useOutsideAlerter(optionsRef, setShowOptions);
  useOutsideAlerter(rolesRef, setShowRoles);

  useEffect(() => {
    const getAllUsers = () => {
      database.ref(`users`).on("value", (snapshot) => {
        const array = [];
        snapshot.forEach((childSnapshot) => {
          const id = childSnapshot.key;
          const childData = childSnapshot.val();
          if (childData.username) {
            array.push({ id, ...childData });
          }
        });
        setAllUsers(array);
      });
    };
    getAllUsers();
  }, []);

  const matchYoutubeUrl = (url) => {
    const reg = new RegExp("^https://www.youtube.com/watch?");
    if (reg.test(url)) {
      setYoutubeLinkErr(null);
      const urlId = url.substring(32);
      setVideoImage(`https://img.youtube.com/vi/${urlId}/default.jpg`);
      return setYoutubeLink(url);
    }
    return setYoutubeLinkErr(
      "Please enter url following format i.e https://www.youtube.com/watch?v=MIVW0sijSjY"
    );
  };

  useEffect(() => {
    if (selectedRole && youtubeLink && videoTrackName) {
      setPublishActive(true);
    }
  }, [selectedRole, youtubeLink]);

  useEffect(() => {
    if (
      selectedType === "Video" &&
      selectedRole &&
      youtubeLink &&
      videoTrackName
    ) {
      setPublishActive(true);
    } else if (selectedType === "Audio" && artistName && trackName) {
      setPublishActive(true);
    } else {
      setPublishActive(false);
    }
  }, [
    selectedType,
    selectedRole,
    youtubeLink,
    videoTrackName,
    artistName,
    trackName,
    videoImage,
  ]);

  useEffect(() => {
    setValues({
      ...values,
      youtubeLink,
      selectedRole,
      artistName,
      selectedType,
    });
  }, [selectedRole, youtubeLink, artistName, selectedType]);

  const onSelectType = (v) => {
    setSelectedType(v);
    setShowOptions(false);
  };

  useEffect(() => {
    const getTrackInfos = () => {
      axios({
        method: "get",
        url:
          "https://us-central1-creditzmusic.cloudfunctions.net/httpsSpotifyToken-spotifyToken/searchTrackArtist",
        params: {
          artist: artistName,
          track: trackName,
        },
      })
        .then((res) => {
        })
        .catch((err) => {
        });
    };
    if (artistName && trackName) {
      getTrackInfos();
    }
  }, [artistName, trackName]);

  const onPublish = () => {
    if (selectedType === "Video") {
      if (!videoImage || !videoTrackName) {
        return;
      } else {
        dispatch({
          type: creditzActions.CREATE_VIDEO_CREDITZ,
          payload: {
            data: {
              ...values,
              videoImage,
              timestamp: new Date().getTime(),
              videoTrackName,
              role: selectedRole,
              trackUrl: youtubeLink,
            },
            additionalRoles: additionalRoles,
          },
        });
      }
    } else if (selectedType === "Audio") {
      if (!artistName || !trackName) {
        return;
      } else {
        dispatch({
          type: creditzActions.CREATE_VIDEO_CREDITZ,
          payload: {
            data: {
              ...values,
              albumImage: "https://i.scdn.co/image/ab67616d0000b2735595a4c733f6db29d4b90cb5",
              timestamp: new Date().getTime(),
              trackName,
              role: selectedRole,
              trackUrl: youtubeLink,
            },
            additionalRoles: additionalRoles,
          },
        });
      }
    }
  };

  return (
    <>
      <Row justify="space-between" align="top">
        <Col span={12} />
        <Col span={12}>
          <div className={`${styles.genericButton}`}>
            <div>
              <button
                className={`${styles.button} ${
                  !publishActive ? styles.publish : ""
                }`}
                disabled={!publishActive}
                onClick={onPublish}
              >
                Publish
              </button>
            </div>
          </div>
        </Col>
      </Row>
      <div className={styles.CreateNewCreditzContainer}>
        <div className={styles.selectTypeContainer} ref={optionsRef}>
          <div
            className={styles.selectedType}
            onClick={() => setShowOptions(true)}
          >
            <div className={styles.select}>{selectedType}</div>
            <SelectArrow />
          </div>
          {showTypesOptions && (
            <div className={styles.options}>
              <div
                className={styles.option}
                onClick={() => onSelectType("Video")}
              >
                Video
              </div>
              <div
                className={styles.option}
                onClick={() => onSelectType("Audio")}
              >
                Audio
              </div>
            </div>
          )}
        </div>
        <div className={styles.selectOptionContainer} ref={rolesRef}>
          <div className={styles.label}>My Role</div>
          <div>
            <div
              className={styles.selectedType}
              onClick={() => setShowRoles(true)}
            >
              <div className={styles.select}>{selectedRole}</div>
              <SelectArrow />
            </div>
            {showRolesOptions && (
              <div className={styles.options}>
                {userRoles.map((role) => (
                  <div
                    key={role}
                    className={styles.option}
                    onClick={() => {
                      setSelectedRole(role);
                      setShowRoles(false);
                    }}
                  >
                    {role}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        {selectedType === "Video" && (
          <>
            <div className={styles.urlContainer}>
              <div className={styles.label}>URL</div>
              <input
                placeholder="Insert URL Here"
                onChange={(e) => matchYoutubeUrl(e.target.value)}
                value={youtubeLink}
              />
            </div>
            {youtubeLinkErr && (
              <span style={{ marginLeft: 126, color: "red", fontSize: "12px" }}>
                {youtubeLinkErr}
              </span>
            )}
          </>
        )}
        {selectedType === "Video" && youtubeLink && !youtubeLinkErr && (
          <>
            <div className={styles.urlContainer}>
              <div className={styles.label}>Video Title</div>
              <input
                placeholder="Insert Video Title"
                onChange={(e) => setVideoTitle(e.target.value)}
                value={videoTrackName}
              />
            </div>
          </>
        )}
        {selectedType === "Audio" && (
          <>
            <div className={styles.urlContainer}>
              <div className={styles.label}>Artist Name</div>
              <input
                placeholder="Insert Artist Name Here"
                onChange={(e) => setArtistName(e.target.value)}
                value={artistName}
              />
            </div>
            <div className={styles.urlContainer}>
              <div className={styles.label}>Track Name</div>
              <input
                placeholder="Insert Track Name Here"
                onChange={(e) => setTrackName(e.target.value)}
                value={trackName}
              />
            </div>
          </>
        )}

        <div className={styles.MusicBigContainer}>
          {selectedType === "Video" && (
            <div
              style={{
                backgroundImage: `url(${videoImage ? videoImage : musicBig})`,
                width: videoImage ? 550:350
              }}
            />

          )}
          {selectedType === "Audio" && (
            <div
              style={{
                backgroundImage: `url(${
                  videoTrackName ? videoTrackName : musicBig
                })`,
              }}
            />
          )}
        </div>
        <div className={styles.additionalInfos}>
          <div className={styles.title}>Creditz</div>
          {additionalRoles.map((role, index) => (
            <AddNewAdditionalInfo
              setAdditionalUser={setAdditionalUser}
              key={index}
              addRole={role}
              allUsers={allUsers}
            />
          ))}
          <div className={styles.addNewAdditionalInfo}>
            <button
              onClick={() =>
                setAddRoles([
                  ...additionalRoles,
                  { i: additionalRoles.length, role: "", username: "" },
                ])
              }
            >
              + Add
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

CreateNewCreditzForm.propTypes = {
  setPublishActive: PropTypes.func,
  // setValues: PropTypes.setValues,
  // values: PropTypes.values,
  publishActive: PropTypes.bool,
  setView: PropTypes.func,
  additionalRoles1: PropTypes.array,
};

CreateNewCreditzForm.defaultProps = {
  values: PropTypes.object,
  additionalRoles1: [{ i: 0, role: "", username: "" }],
  setPublishActive: () => {
  },
  setValues: () => {
  },
  publishActive: false,
  setView: () => {
  },
};

export default CreateNewCreditzForm;
